// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__20KzP","label":"LabeledBox_label__12i1i"};